export default "__VITE_ASSET__1VK8bU$y__"